import React from 'react';
import PropTypes from 'prop-types';
import { CodeEditor } from 'axway-react-ui';
import { Button, Glyphicon, Modal } from 'react-bootstrap';

/**
 * A dialog that shows text/instructions and has a CodeEditor (shell) component.
 */
class CommandDialog extends React.Component {
	renderButtons() {
		const {
			onOkay,
			okayText,
			okayIcon,
			closeText,
			onClose
		} = this.props;

		const hasOkay = onOkay && okayText;
		const icon = okayIcon && <Glyphicon glyph={` gg icon-GG-${okayIcon}`} />;

		const buttons = [
			<Button
				key="close"
				bsStyle={hasOkay ? 'link' : 'primary'}
				bsSize="large"
				className="cancel"
				onClick={onClose}
			>
				{closeText}
			</Button>
		];
		if (hasOkay) {
			buttons.push(
				<Button
					key="okay"
					bsStyle="primary"
					bsSize="large"
					className="okay"
					onClick={onOkay}
				>
					{icon}
					{okayText}
				</Button>
			);
		}
		return buttons;
	}

	render() {
		const {
			title,
			text,
			command,
			onClose
		} = this.props;

		return (
			<Modal
				show
				keyboard
				className="command-dialog"
				backdrop="static"
				onHide={onClose}
			>
				<Modal.Header>
					<Modal.Title>
						{title}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{text}
					<CodeEditor
						readOnly
						nocursor
						className="command-line"
						mode="shell"
						theme="eclipse"
						lineNumbers={false}
						lineWrapping
						copyButton
						code={command}
					/>
				</Modal.Body>
				<Modal.Footer>
					{this.renderButtons()}
				</Modal.Footer>
			</Modal>
		);
	}
}

CommandDialog.propTypes = {
	/**
	 * The dialog title.
	 */
	title: PropTypes.string.isRequired,
	/**
	 * The main dialog text. This can be JSX.
	 */
	text: PropTypes.element,
	/**
	 * The shell command to display in the dialog.
	 */
	command: PropTypes.string.isRequired,
	/**
	 * The text of the "Close" button.
	 */
	closeText: PropTypes.string.isRequired,
	/**
	 * Callback when the "Close" button is clicked.
	 */
	onClose: PropTypes.func.isRequired,
	/**
	 * The text of the "OK" button.
	 */
	okayText: PropTypes.string,
	/**
	 * Callback when "OK" button is clicked.
	 */
	onOkay: PropTypes.func,
	/**
	 * An icon to show with the "OK" button.
	 */
	okayIcon: PropTypes.string
};

CommandDialog.defaultProps = {
	okayIcon: null
};

export default CommandDialog;
